var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-3 pb-2 px-5 fl-x fl-te-c fl-a-c border-r-2 bg-4",class:{'bg-primary':_vm.color === 'primary','text-primary':_vm.color===''}},[_c('div',[(_vm.heading !=='')?_c('h5',{},[_vm._v(_vm._s(_vm.heading))]):_c('div',{staticClass:"fl-x"},[_vm._t("header")],2)]),_c('div',{staticClass:"btn-group btn-block"},[_vm._t("buttons")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }